import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { apiGet } from 'APIPackage/MainModule/common/apiTools';

import { IListType } from '../interfaces/IListType';

export async function fetchListTypes(): Promise<IListType[]> {
  return apiGet<IListType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/list-types`);
}
